/**
 * Наклон телефона как React-состояние.
 *
 * Мост между @taro/tg (знает про Telegram) и @taro/cards (не знает и знать
 * не должен). Живёт в приложении именно поэтому: это единственный слой,
 * которому разрешено видеть обе стороны.
 *
 * Если наклон недоступен — а это все, кто вне Telegram, и все, у кого
 * клиент старее Bot API 8.0, — хук возвращает null навсегда, и фольга
 * работает от пальца. Отдельного флага «поддерживается» наружу нет
 * намеренно: карте всё равно, откуда пришло движение.
 */

import { useEffect, useState } from 'react'

import { watchTilt, type Tilt } from '@taro/tg'

/**
 * Порог обновления состояния.
 *
 * Гироскоп шлёт 30 раз в секунду и не замолкает, когда телефон лежит
 * на столе: там всегда есть дрожь в третьем знаке. Без порога это
 * 30 перерисовок React в секунду ради движения, которого не видно.
 */
const DEADZONE = 0.012

export function useDeviceTilt(enabled: boolean): Tilt | null {
  const [tilt, setTilt] = useState<Tilt | null>(null)

  useEffect(() => {
    if (!enabled) {
      setTilt(null)
      return
    }

    let last: Tilt | null = null

    const stop = watchTilt((next) => {
      if (last && Math.abs(next.x - last.x) < DEADZONE && Math.abs(next.y - last.y) < DEADZONE) {
        return
      }
      last = next
      setTilt(next)
    })

    return stop
  }, [enabled])

  return tilt
}
